import "core-js/stable";
import Vue from "vue";
import CoreuiVue from "@coreui/vue";
import App from "./App";
import "@babel/polyfill";
import router from "./router/index";
import { iconsSet as icons } from "./assets/icons/icons.js";
import store from "./store";
import { getStoreFromLocalStorage } from "./store";
import VueApollo from "vue-apollo";
import VModal from "vue-js-modal";
import BootstrapVueTreeview from "bootstrap-vue-treeview";
import "vue-tree-halower/dist/halower-tree.min.css";
import VTree from "vue-tree-halower";
import QuickEdit from "vue-quick-edit";
import VueCompositionApi from "@vue/composition-api";
import CoreuiVueCharts from "@coreui/vue-chartjs";
import axios from "axios";
import VueAxios from "vue-axios";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faUserSecret } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import VueSession from "vue-session";
import SuccessModal from "./views/Reuse/SuccessModal";
import ErrorModal from "./views/Reuse/ErrorModal";
import Confirmation from "./views/Reuse/ConformationModal";
import ImportModal from "./views/Reuse/ImportModal";
import ImportModalMulti from "./views/Reuse/ImportModalMulti";
import ExportModal from "./views/Reuse/ExportModal";

import "@fortawesome/fontawesome-free/css/all.css";
import "@fortawesome/fontawesome-free/js/all.js";
import VueHtml2Canvas from "vue-html2canvas";

import ApolloClient from "./api/apollo/apolloSetup";

import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';

library.add(faUserSecret);

Vue.use(VueHtml2Canvas);
Vue.use(VueSession);
Vue.component("Success", SuccessModal);
Vue.component("Error", ErrorModal);
Vue.component("Confirm", Confirmation);
Vue.component("font-awesome-icon", FontAwesomeIcon);
Vue.component("quick-edit", QuickEdit);
Vue.component("Import", ImportModal);
Vue.component("ImportMulti", ImportModalMulti);
Vue.component("Export", ExportModal);
Vue.use(CoreuiVueCharts);
Vue.use(VueCompositionApi);
Vue.use(VTree);
Vue.use(BootstrapVueTreeview);
Vue.use(CoreuiVue);
Vue.use(VueApollo);
Vue.use(VModal);
Vue.prototype.$log = console.log.bind(console);
Vue.use(VueAxios, axios);

// Apollo setup in api/apollo/apolloSetup.js
const apolloProvider = new VueApollo({
    defaultClient: ApolloClient
});
Vue.prototype.$themeColors = {
    green: {
        "100": "#b1d8b7",
        "200": "#94c973",
        "300": "#2f5233",
        "400": "#6F8695"
    }
};

new Vue({
    el: "#app",
    router,
    store,
    ApolloClient,
    apolloProvider,
    icons,
    template: "<App/>",
    beforeCreate() {
        getStoreFromLocalStorage();
    },
    components: {
        App
    }
});
